import React from "react";
import { CircularProgress } from "@mui/material";

function LoadingProgress() {
  return (
    <div className="w-full h-full flex items-center justify-center">
      <CircularProgress size={40} />
    </div>
  );
}

export default LoadingProgress;
